import { render, staticRenderFns } from "./CategoryInstructionsModal.vue?vue&type=template&id=d34d6146&scoped=true&"
import script from "./CategoryInstructionsModal.vue?vue&type=script&lang=js&"
export * from "./CategoryInstructionsModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInstructionsModal.vue?vue&type=style&index=0&id=d34d6146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34d6146",
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Template: require('/lasso/components/templates/Template.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d34d6146')) {
      api.createRecord('d34d6146', component.options)
    } else {
      api.reload('d34d6146', component.options)
    }
    module.hot.accept("./CategoryInstructionsModal.vue?vue&type=template&id=d34d6146&scoped=true&", function () {
      api.rerender('d34d6146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/questions/CategoryInstructionsModal.vue"
export default component.exports